export class CreateCustomRule {
    ruleType: string;
    ruleName: string;
    ruleAmount: string;
    createRuleTransactionType: CreateRuleTransactionType;
    createRuleParty: CreateRuleParty;
    createRuleAuthorization: CreateRuleAuthorization;
}

export class CreateRuleTransactionType {
    createRuleAch: boolean;
    createRuleAllTransactionType: boolean;
    createRuleCheck: boolean;
    createRuleIt: boolean;
    createRuleWire: boolean;
}

export class CreateRuleParty {
    createRuleAllParty: boolean;
    createRuleFirstParty: boolean;
    createRuleThirdParty: boolean;
}

export class CreateRuleAuthorization {
    createRuleAllAuth: boolean;
    createRuleNoAuthRequired: boolean;
    createRuleOneTimeAuthRequired: boolean;
    createRuleStandingAuth: boolean;
}

export interface CustomRulePostRequest {
    data: {
        attributes: {
            contextName: string;
            transactionTypes: string[];
            threshold: number;
            ruleType: string;
            party: string[];
            authorization: string[];
        };
        type: string;
    }
}

export interface CustomRulePostResponse {
    data: {
        attributes: {
            id: string;
            contextId: string;
            contextName: string;
            transactionTypes: string[];
            threshold: number;
            ruleType: string;
            party: string[];
            authorization: string[];
            createdBy: string;
            dateCreated: string;
        };
        type: string;
        id: string;
    };
}

export interface CustomRuleGetResponseData {
    id: string;
    type: string;
    attributes: CustomRuleAttributes;
}

export interface CustomRuleAttributes {
    contextId: string;  
    contextName: string;
    transactionTypes: string[];
    threshold: number;
    party: string[];
    authorization: string[];
    createdBy: string;
    dateCreated: string;
    ruleType: string;
}

export interface CustomRuleListTableColumn {
  'actions': string;
  'ruleName': string;
  'transactionTypes': string | string[];
  'party': string | string[];
  'authorization': string | string[];
  'amount': string | number;
  'id': string;
  'dateCreated': string;
  'ruleType': string;
}

export enum TableValuesFormat {
  ACH = 'ach',
  CHECK = 'check',
  WIRE = 'wire',
  INTERNALTRANSFER = 'internal-transfer',
  NOCLIENTAUTH = 'no-auth-required',
  ONETIMECLIENTAUTH = 'one-time-client-auth',
  STANDINGAUTH = 'standing-auth',
  FIRSTPARTY = '1st-party',
  THIRDPARTY = '3rd-party'
}

export const TableValuesFormatDisplay: Record<TableValuesFormat, string> = {
  [TableValuesFormat.ACH] : 'ACH',
  [TableValuesFormat.CHECK] : 'Check',
  [TableValuesFormat.WIRE] : 'Wire',
  [TableValuesFormat.INTERNALTRANSFER]: 'Internal transfer',
  [TableValuesFormat.NOCLIENTAUTH]: 'No client authorization required',
  [TableValuesFormat.ONETIMECLIENTAUTH]: 'One-time client authorization',
  [TableValuesFormat.STANDINGAUTH]: 'Standing authorization',
  [TableValuesFormat.FIRSTPARTY]: '1st Party',
  [TableValuesFormat.THIRDPARTY]: '3rd Party'
}
